import React, { useContext } from "react";
import getImg from "../../assets/image/slider1.jpg";
import { NavLink } from "react-router-dom";
import { LanguageContext } from "../../context/LanguageContext";
import translations from "../../data/langData";
const GetInTouch = () => {
  const { language } = useContext(LanguageContext);
  const t = translations[language];
  return (
    <>
      <section className="getintouch">
        <div className="outline"></div>
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12 col-12 ">
              <div className="getBox" data-aos="fade-up">
                <h1>{t.contactweTitle}</h1>
                <p>
                 {t.contactweDesc}
                </p>
                    <NavLink to="/coachingsubs">
                <button className="btn btn-primary">
                    {t.contactwe}
                </button>
                    </NavLink>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default GetInTouch;
